import { AppState } from "../src/taskpane/components/App";
import axiosBaseURL from "../utilities/httpCommon";
/*
    Managing the dialogs.
*/

/* global Office location OfficeRuntime console localStorage */
//axios.defaults.baseURL = process.env.REACT_APP_API_KEY;

let loginDialog: Office.Dialog;
const dialogLoginUrl: string =
  location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") + "/login.html";

export const signInSF = async (
  setState: (x: AppState) => void,
  setToken: (x: string) => void,
  displayError: (x: string) => void,
  loginmode: string
) => {
  setState({ authStatus: "loginInProcess" });
  console.log(dialogLoginUrl + "?mode=" + loginmode);
  await Office.context.ui.displayDialogAsync(
    dialogLoginUrl + "?mode=" + loginmode,
    { height: 40, width: 30 },
    (result) => {
      if (result.status === Office.AsyncResultStatus.Failed) {
        displayError("${result.error.code} ${result.error.message}");
      } else {
        loginDialog = result.value;
        loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLoginMessage);
        loginDialog.addEventHandler(Office.EventType.DialogEventReceived, processLoginDialogEvent);
      }
    }
  );

  const processLoginMessage = (arg: { message: string; origin: string } | { message: string; error: number }) => {
    let messageFromDialog = JSON.parse(arg.message);
    if (messageFromDialog.status === "success") {
      // We now have a valid access token.
      loginDialog.close();
      // Checking Server
      //axios.defaults.baseURL = "http://localhost:5000";
      //axios.defaults.baseURL = "http://localhost:5000";
      //console.log(axios.defaults.baseURL);
      GetTokenfromSF(messageFromDialog.result)
        .then((result) => {
          if (result != null) {
            try {
              let value = JSON.parse(result);
              setToken(value.data.token);
              setState({ authStatus: "loggedIn", headerMessage: "Get Data" });
              OfficeRuntime.storage.setItem("authstatus", "1");
            } catch (err) {
              console.log(err);
              displayError("ERROR:" + err.message);
              setState({ authStatus: "notLoggedIn", headerMessage: "Welcome" });
            }
          } else {
            setState({ authStatus: "notLoggedIn", headerMessage: "Welcome" });
          }
        })
        .catch((error) => {
          console.log(error);
          displayError(error.message);
        });
      // Ends here
    } else {
      // Something went wrong with authentication or the authorization of the web application.
      loginDialog.close();
      displayError(messageFromDialog.result);
    }
  };

  const processLoginDialogEvent = (arg) => {
    processDialogEvent(arg, setState, displayError);
  };

  const GetTokenfromSF = async (authcode: string) => {
    try {
      const res = await axiosBaseURL
        .get("/sfserver/auth/authorize?code=" + authcode, {
          withCredentials: true,
        })
        .catch((error) => {
          console.log("error==");
          console.log(error);
          if (error.response) {
            throw new Error(error.response.data);
          } else if (error.request) {
            throw new Error(error.request);
          } else {
            throw new Error(error.message);
          }
        });
      console.log("Logged in user");
      console.log(res);
      const userdetails = await axiosBaseURL.get("/sfserver/auth/whoami", {
        withCredentials: true,
      });
      console.log("userdetails:");
      console.log(userdetails);
      if (userdetails != null) {
        localStorage.setItem("sfuserinfo", userdetails.data.username);
        localStorage.setItem("sfuserid", userdetails.data.user_id);
      }
      return JSON.stringify(res);
    } catch (err) {
      throw new Error("ERROR=>" + err.message);
    }
  };
};

let logoutDialog: Office.Dialog;
const dialogLogoutUrl: string =
  location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "") + "/logout/logout.html";

export const logoutFromO365 = async (setState: (x: AppState) => void, displayError: (x: string) => void) => {
  Office.context.ui.displayDialogAsync(dialogLogoutUrl, { height: 40, width: 30 }, (result) => {
    if (result.status === Office.AsyncResultStatus.Failed) {
      displayError(`${result.error.code} ${result.error.message}`);
    } else {
      logoutDialog = result.value;
      logoutDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLogoutMessage);
      logoutDialog.addEventHandler(Office.EventType.DialogEventReceived, processLogoutDialogEvent);
    }
  });

  const processLogoutMessage = () => {
    logoutDialog.close();
    setState({ authStatus: "notLoggedIn", headerMessage: "Welcome" });
  };

  const processLogoutDialogEvent = (arg) => {
    processDialogEvent(arg, setState, displayError);
  };
};

const processDialogEvent = (
  arg: { error: number; type: string },
  setState: (x: AppState) => void,
  displayError: (x: string) => void
) => {
  switch (arg.error) {
    case 12002:
      displayError(
        "The dialog box has been directed to a page that it cannot find or load, or the URL syntax is invalid."
      );
      break;
    case 12003:
      displayError("The dialog box has been directed to a URL with the HTTP protocol. HTTPS is required.");
      break;
    case 12006:
      // 12006 means that the user closed the dialog instead of waiting for it to close.
      // It is not known if the user completed the login or logout, so assume the user is
      // logged out and revert to the app's starting state. It does no harm for a user to
      // press the login button again even if the user is logged in.
      setState({ authStatus: "notLoggedIn", headerMessage: "Welcome" });
      break;
    default:
      displayError("Unknown error in dialog box.");
      break;
  }
};
